const styles = {
  btn_portal_custom: {
    padding: "8px 16px",
  },

  optionButton: {
    padding: "12px 24px",
    borderRadius: "12px",
    border: "1px solid #23DC9F !important",
    cursor: "pointer",
    fontSize: "16px",
    color: "white",
    fontWeight: 500,
    fontFamily: "byker, sans-serif",
  },
  optionButtonSelected: {
    backgroundColor: "#23DC9F",
    color: "#421F66",
    fontSize: "16px",
    fontWeight: 500,
    borderColor: "#23DC9F",
    fontFamily: "byker, sans-serif",
  },
  optionButtonUnselected: {
    backgroundColor: "#421F66",
    color: "white",
    border: "1px solid #23DC9F",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "10px",
  },
  gridItem: {
    minWidth: "180px",
  },

  common_border_styles: {
    border: "1px solid #00DF99",
    borderRadius: "12px",
    // padding: "32px",
  },
  // Positions
  top35P: {
    top: "35%",
  },
  top50P: {
    top: "45%",
  },
  //paddings

  paddingV10H16: {
    padding: "10px 16px",
  },
  paddingV10H18: {
    padding: "10px 18px",
  },

  //borderColors

  border1pxSolidgreen: {
    border: "1px solid #23DC9F",
  },

  //borderBottom
  borderBottom1pxsolidblue: {
    borderBottom: "1px solid #421F66",
  },
  borderBottomLeftRadius12: {
    borderBottomLeftRadius: 12,
  },
  borderBottomRightRadius12: {
    borderBottomRightRadius: 12,
  },

  //borderTop
  borderTop1pxsolidblue: {
    borderTop: "1px solid #421F66",
  },
  borderTopLeftRadius12: {
    borderTopLeftRadius: "12px",
  },
  borderTopRightRadius12: {
    borderTopRightRadius: "12px",
  },
};
export default styles;
